import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/LegalPages.css';

const ImpressumPage = () => (
  <>
    <Helmet>
      <title>Impressum | DynaStoxx</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div className="legal-container">
      <div className="legal-card">
        <h1>Impressum</h1>

        <section>
          <h2>Angaben gemäß § 5 DDG</h2>
          <p>Christian Lamping<br />Mühlenstraße 19<br />49429 Visbek<br />Deutschland</p>
        </section>

        <section>
          <h2>Kontakt</h2>
          <p>Du erreichst uns über das <a href="#kontakt">Kontaktformular</a> am Seitenende.</p>
        </section>

        <section>
          <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p>Christian Lamping<br />Mühlenstraße 19<br />49429 Visbek</p>
        </section>

        <section>
          <h2>Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.
          </p>
          <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        </section>

        <section>
          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
            Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen
            zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
        </section>

        <section>
          <h2>Keine Anlageberatung</h2>
          <p>
            Alle Inhalte auf DynaStoxx dienen ausschließlich der Information und Bildung. Sie stellen keine Anlageberatung,
            Empfehlung oder Aufforderung zum Kauf oder Verkauf von Wertpapieren dar. Investitionen bergen Risiken bis hin zum Totalverlust.
          </p>
        </section>
      </div>
    </div>
  </>
);

export default ImpressumPage;
